import { SCOPE_BY_ID, zoomLabel } from '@vm/content';

/**
 * Preview chip of a weapon sight: the reticle (or a masked-scope ring) on a dark lens, plus a small "zoom" tag for magnified
 * scopes. Pure CSS, no images. 'none' shows an empty lens.
 */
export function ScopeSwatch(props: { id: string; big?: boolean }) {
  const def = SCOPE_BY_ID[props.id];
  const masked = !!def?.masked;
  const reticle = def?.reticle ?? null;
  const zoom = def?.zoom ?? null;
  return (
    <span class={`scope-swatch ${props.big ? 'big' : ''} ${masked ? 'is-masked' : ''}`} aria-hidden="true">
      <span class="scope-lens">
        {masked ? (
          <>
            <i class="ss-h" />
            <i class="ss-v" />
          </>
        ) : reticle ? (
          <i class={`ss-reticle ss-${reticle}`} />
        ) : (
          <i class="ss-iron" />
        )}
      </span>
      {zoom !== null && zoom < 0.7 && <small class="scope-zoom">{zoomLabel(zoom)}</small>}
    </span>
  );
}
